import React from 'react';
import {
  TextField,
  Box,
  FormControlLabel,
  Checkbox,
  ThemeProvider,
  FormGroup,
  Stack,
} from '@mui/material';
import responseInputMuiTheme from 'pages/Forms/Theme/responseInputMuiTheme';
import { AlertMessage } from 'pages/Forms/components/AlertMessage/AlertMessage';
import { selectedActionInputStyles } from 'pages/Forms/Theme/responseInputStyles';
import useOptionsInputs from 'pages/Forms/RegisterForm/CustomFormBuilder/Header/Preview/TableFormFieldPreview/TableCellPreview/hooks/useOptionsInputs';
import { TableFieldPreviewProps } from 'pages/Forms/RegisterForm/CustomFormBuilder/Header/type/preview.type';
import { ChoiceImagePreview } from 'pages/Forms/RegisterForm/CustomFormBuilder/Header/Preview/ChoiceImagePreview';

const CheckboxPreview: React.FC<TableFieldPreviewProps> = (props) => {
  const theme = responseInputMuiTheme;

  const {
    textFieldRef,
    otherText,
    showActionMessage,
    handleChange,
    handleOtherTextChange,
    isSelected,
  } = useOptionsInputs({
    ...props,
    inputType: 'checkbox',
  });

  return (
    <ThemeProvider theme={theme}>
      <Box key={props.field.id} m={1}>
        <FormGroup>
          {props.field.choice?.map((choice) => (
            <Stack key={choice.id} spacing={1}>
              <FormControlLabel
                control={
                  <Checkbox
                    onChange={() => handleChange(choice.id)}
                    color="primary"
                    checked={isSelected(choice.id)}
                  />
                }
                label={
                  <Stack>
                    <ChoiceImagePreview choice={choice} />
                    {choice.label}
                  </Stack>
                }
                sx={
                  isSelected(choice.id) && choice.action
                    ? selectedActionInputStyles(theme)
                    : {}
                }
                disabled={props.shouldBeReadOnly}
              />
              {choice.isOtherField && isSelected(choice.id) && (
                <TextField
                  inputRef={textFieldRef}
                  value={otherText}
                  onChange={(e) => handleOtherTextChange(e.target.value)}
                  placeholder="Your answer"
                  fullWidth
                  onFocus={(e) => e.target.select()}
                  disabled={props.shouldBeReadOnly}
                />
              )}
            </Stack>
          ))}
        </FormGroup>

        {showActionMessage && props.field.actionMessage && (
          <Box mt={1}>
            <AlertMessage alertMessage={props.field.actionMessage} />
          </Box>
        )}
      </Box>
    </ThemeProvider>
  );
};

export default CheckboxPreview;
